import { render } from "./GiftPack.vue?vue&type=template&id=49c314e6"
import script from "./GiftPack.vue?vue&type=script&lang=js"
export * from "./GiftPack.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__